// assets/db-user-list-page.js
(() => {
  const API_BASE = window.GD_API_BASE || 'https://gear-db-proxy.onrender.com';

  // ---- helpers
  const esc = (s)=>String(s??'').replace(/[&<>"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));
  const timeAgo = (t)=>{ if(!t) return 'No activity yet';
    const d=new Date(t); const s=((Date.now()-d)/1000)|0;
    if(s<5) return 'just now'; if(s<60) return s+'s ago';
    const m=(s/60)|0; if(m<60) return m+'m ago';
    const h=(m/60)|0; if(h<24) return h+'h ago';
    const dd=(h/24)|0; if(dd===1) return 'yesterday';
    if(dd<7) return dd+'d ago'; const w=(dd/7)|0; if(w<5) return w+'w ago';
    const mo=(dd/30)|0; if(mo<12) return mo+'mo ago'; const y=(dd/365)|0; return y+'y ago';
  };
  const initials = (name, fb='?')=>{
    if(!name) return fb;
    const p=name.trim().split(/\s+/); return ((p[0]?.[0]||'')+(p[p.length-1]?.[0]||'')).toUpperCase()||fb;
  };
  const profileLink = (u) => {
    if (u.display_name) return `/pages/profile?u=${encodeURIComponent(u.display_name)}`;
    return `/pages/profile?cid=${encodeURIComponent(u.customer_id)}`;
    };
    const nl2sp = (s) => String(s||'').replace(/\s+/g,' ').trim();

    // status dot color by recency
    function onlineStatus(lastAt){
    if(!lastAt) return { cls:'st-off', label:'No activity yet' };
    const s = (Date.now() - new Date(lastAt).getTime())/1000;
    if (s <= 300)  return { cls:'st-on',   label:'Active now' };      // <5m
    if (s <= 86400) return { cls:'st-idle', label:'Active today' };   // <24h
    return { cls:'st-off', label:'Inactive' };
    }
    function levelPill(u){
    const lvl = Number(u.level||0); const xp = Number(u.total_xp||0);
    return (lvl||xp) ? ` <span class="ul-pill" title="Level ${lvl} ${xp} XP">Lvl ${lvl || 1}</span>` : '';
    }
    function isFeatured(u){
    if (!u.joined_at) return false;
    const days = (Date.now() - new Date(u.joined_at).getTime()) / 86400000;
    return days <= 7; // joined in the last 7 days
    }

    function renderFeatured(list){
    const box = document.getElementById('ul-featured');
    if (!box) return;
const featured = list
  .filter(isFeatured) // joined_at within 7 days
  .sort((a,b) => new Date(b.joined_at || 0) - new Date(a.joined_at || 0));
      if (!featured.length) { box.innerHTML = ''; return; }
    const html = featured.map(u=>{
        const name = u.display_name || `User ${String(u.customer_id||'').slice(-6)}`;
        const banner = u.cover_image_url || '';
        const ava = u.avatar_url
        ? `<img class="ulf-ava" loading="lazy" src="${esc(u.avatar_url)}" alt="">`
        : `<div class="ulf-ava placeholder">${esc(initials(name))}</div>`;
        const lastTitle = u.last_at ? esc(new Date(u.last_at).toLocaleString()) : '';
        const href = profileLink(u);
        const origin = (new URL('/', window.location.href)).origin;
        const fullLink = origin + href;
        const bio = nl2sp(u.bio||'');
        const safeBanner = banner ? ` style="background-image:url('${esc(banner)}')"` : '';
        return `
        <div class="ulf-card" data-href="${esc(href)}" role="button" tabindex="0">
            <div class="ulf-badge">New this week</div>
            <div class="ulf-banner"${safeBanner} loading="lazy"></div>
            <div class="ulf-body">
            ${ava}
            <div class="ulf-main">
                <div class="ulf-name">${esc(name)}</div>
                <div class="ulf-meta" title="${lastTitle}">${esc(timeAgo(u.last_at))}</div>
            </div>
            </div>
            ${bio ? `<div class="ulf-bio">${esc(bio)}</div>` : ''}
            <button class="ulf-link" type="button" data-copy="${esc(fullLink)}">Copy link</button>
        </div>
        `;
    }).join('');

    box.innerHTML = `<div class="ulf-track">${html}</div>`;
    }

    // ---- Activity (shared timeAgo/esc already exist)
function kindLabel(k, sub){ 
  if (k === 'reaction') return `${sub || 'Reaction'}`;
  return k.charAt(0).toUpperCase()+k.slice(1);
}

function renderActivity(items){
  const feed = document.getElementById('ua-feed');
  const empty = document.getElementById('ua-empty');
  if (!feed) return;

  if (!items.length) {
    feed.innerHTML = '';
    if (empty) empty.hidden = false;
    return;
  }
  if (empty) empty.hidden = true;

  feed.innerHTML = items.map(it => {
    const img = it.product_image_url ? 
      `<img class="ua-thumb" src="${esc(it.product_image_url)}" loading="lazy" alt="">` :
      `<div class="ua-thumb"></div>`;
    const title = esc(it.product_title || `Product ${it.product_id || ''}`);
    const whenTitle = it.at ? esc(new Date(it.at).toLocaleString()) : '';
    const href = it.product_handle ? `/pages/geardb?handle=${encodeURIComponent(it.product_handle)}` : '#';
    const text = (it.text || '').trim();
    const kind = esc(kindLabel(it.kind, it.subtype));

    return `
      <li class="ua-item">
        ${img}
        <div class="ua-main">
          <div class="ua-head">
            <span class="ua-kind">${kind}</span>
            <a class="ua-title" href="${href}" target="_blank" rel="noopener">${title}</a>
            <span class="ua-meta" title="${whenTitle}">${esc(timeAgo(it.at))}</span>
          </div>
          ${text ? `<div class="ua-text">${esc(text)}</div>` : ``}
        </div>
      </li>`;
  }).join('');
}

let _uaCache = { all: [], lastFetch: 0 };
async function loadActivityFeed({ force=false } = {}){
  const now = Date.now();
  if (!force && _uaCache.all.length && (now - _uaCache.lastFetch) < 30_000) {
    renderActivity(filterActivity(_uaCache.all));
    return;
  }
  try{
    const r = await fetch((window.GD_API_BASE||'') + '/activity/latest?limit=50', { cache:'no-store' });
    const data = await r.json();
    const list = Array.isArray(data?.items) ? data.items : [];
    _uaCache = { all: list, lastFetch: Date.now() };
    renderActivity(filterActivity(list));
  }catch(e){
    console.warn('[user-list] activity load failed', e);
    renderActivity([]);
  }
}

function filterActivity(list){
  const sel = document.getElementById('ua-filter');
  const v = sel?.value || 'all';
  if (v === 'all') return list;
  return list.filter(x => x.kind === v);
}

// --- BLOG TAB STATE + HELPERS --- // ADD
const BLOG = {
  handle: 'news',   // change if your blog handle differs
  page: 1,
  pageSize: 12,
  all: [],
  q: '',
  loaded: false,
  discovering: false
};

async function fetchArticles({ handle, page, limit, q }) {
  const base = location.origin;
  const params = new URLSearchParams({ limit: String(limit||12), page: String(page||1) });
  if (q) params.set('query', q); // only works if theme supports it

  // Try explicit handle
  let url = `${base}/blogs/${encodeURIComponent(handle)}/articles.json?${params}`;
  let res = await fetch(url, { credentials: 'same-origin' });
  if (res.ok) return res.json();

  // Discover first handle if needed
  if (!BLOG.discovering) {
    BLOG.discovering = true;
    const bl = await fetch(`${base}/blogs.json`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null).catch(()=>null);
    const first = bl && (bl.blogs?.[0] || bl[0]);
    if (first?.handle) BLOG.handle = first.handle;
    BLOG.discovering = false;
  }

  url = `${base}/blogs/${encodeURIComponent(BLOG.handle)}/articles.json?${params}`;
  res = await fetch(url, { credentials: 'same-origin' });
  return res.ok ? res.json() : null; // fallback handled in render
}

function blogCardHTML(a){
  const href   = a?.url || (a?.handle ? `/blogs/${BLOG.handle}/${a.handle}` : '#');
  const img    = a?.image?.src || a?.featured_image || '';
  const title  = a?.title || 'Untitled';
  const date   = a?.published_at || a?.created_at || a?.updated_at || '';
  const when   = date ? new Date(date).toLocaleDateString() : '';
  const excerpt= (a?.excerpt || a?.summary_html || a?.body_html || '')
                  .replace(/<[^>]+>/g,'').trim();

  const bg = img ? ` style="background-image:url('${encodeURI(img)}')"` : '';
  return `
    <article class="blog-card">
      <a class="stretched" href="${href}" target="_blank" rel="noopener">
        <div class="blog-thumb"${bg}></div>
      </a>
      <div class="blog-body">
        <h4 class="blog-title"><a href="${href}" target="_blank" rel="noopener">${esc(title)}</a></h4>
        <div class="blog-meta">${when || ''}</div>
        ${excerpt ? `<p class="blog-excerpt">${esc(excerpt)}</p>` : ``}
      </div>
    </article>`;
}

function renderBlogs(){
  const wrap = document.getElementById('blog-list');
  const more = document.getElementById('blog-more');
  if (!wrap) return;

  if (!BLOG.loaded) { wrap.innerHTML = `<div class="gd-empty">Loading…</div>`; return; }

  const upto  = BLOG.page * BLOG.pageSize;
  const slice = BLOG.all.slice(0, upto);

  wrap.innerHTML = slice.length
    ? slice.map(blogCardHTML).join('')
    : `<div class="gd-empty">No posts found.</div>`;

  if (more) more.style.display = BLOG.all.length > slice.length ? '' : 'none';
}

async function loadBlogs({ reset=false } = {}){
  try{
    if (reset) { BLOG.page = 1; BLOG.all = []; }
    const data  = await fetchArticles({ handle: BLOG.handle, page: BLOG.page, limit: BLOG.pageSize, q: BLOG.q });
    const items = Array.isArray(data?.articles) ? data.articles : (Array.isArray(data) ? data : []);
    BLOG.all = reset ? items : BLOG.all.concat(items);
    BLOG.loaded = true;
    renderBlogs();
  }catch{
    BLOG.loaded = true;
    const wrap = document.getElementById('blog-list');
    if (wrap) wrap.innerHTML = `<div class="gd-empty">Could not load blog posts.</div>`;
  }
}

  // ---- state
  const state = { all: [], filtered: [], page: 0, pageSize: 24, q:'', loaded:false };

  // ---- styles (scoped)
  (function css(){
    if (document.getElementById('gd-user-list-css')) return;
    const s=document.createElement('style'); s.id='gd-user-list-css';
    s.textContent = `
      .gd-users-page{max-width:1480px;margin:24px auto;}
      .gd-users-toolbar{display:flex;gap:8px;margin:8px 0 16px}
      #ul-search{flex:1 1 auto;border:1px solid #e5e7eb;border-radius:8px;padding:8px 10px}
      #ul-refresh,#ul-more{border:1px solid #e5e7eb;background:#fff;border-radius:8px;padding:8px 12px;cursor:pointer}
      .gd-users-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:20px;}
@media (max-width:1100px){.gd-users-grid{grid-template-columns:repeat(3,minmax(0,1fr));}}
@media (max-width:800px){.gd-users-grid{grid-template-columns:repeat(2,minmax(0,1fr));}}
@media (max-width:520px){.gd-users-grid{grid-template-columns:1fr;}}
    .ul-card{transition: all 0.3s ease;box-shadow: 0 1px 2px #0000004d;background: #fff;position:relative;display:flex;flex-direction:column;border-radius:5px;background:#fff;overflow:hidden;cursor:pointer}
    .ul-card:hover{box-shadow: 0 5px 10px #0000004d;}
    .ul-banner{height:120px;background:#f3f4f6 center/cover no-repeat}
    .ul-body{display:flex;gap:10px;align-items:center;padding:10px}
    .ul-ava{width:84px;height:84px;border-radius:0.5rem;object-fit:cover;background:#e5e7eb;flex:0 0 auto;border:2px solid #fff;margin-top:-24px}
    .ul-ava.placeholder{display:flex;align-items:center;justify-content:center;font-weight:700;color:#374151}
    .ul-main{min-width:0;flex:1}
    .ul-name{font-size: 22px;font-weight:700;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
    .ul-meta{font-size:12px;color:#6b7280}
    .ul-bio{padding:0 20px 10px 20px;color:#374151;font-size:14px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
    .ul-footer{display:flex;justify-content:flex-end;padding:8px 10px;border-top:1px solid #f1f5f9}
    .ul-link{border:1px solid #e5e7eb;background:#fff;border-radius:8px;padding:6px 10px;font-size:12px;cursor:pointer}
      .gd-empty{padding:24px;color:#6b7280;text-align:center}
      .gd-users-actions{display:flex;justify-content:center;margin:14px 0}
      /* status dot + pill + featured */
    .ul-name-wrap{display:flex;align-items:center;gap:8px}
    .ul-pill{font-size:12px;border-radius:0.5rem;padding:2px 6px;color:#fff;background:#fb0440}
    .ul-badge{position:absolute;top:8px;left:8px;background:#111827;color:#fff;font-size:12px;border-radius:999px;padding:2px 8px}
    /* Featured strip */
    .gd-users-featured{margin-bottom:14px}
    .ulf-track{display:flex;gap:10px;overflow:auto;padding-bottom:4px;scroll-snap-type:x mandatory}
    .ulf-card{min-width:260px;max-width:260px;border:1px solid #e5e7eb;border-radius:12px;background:#fff;overflow:hidden;cursor:pointer;scroll-snap-align:start;position:relative}
    .ulf-banner{height:80px;background:#f3f4f6 center/cover no-repeat}
    .ulf-body{display:flex;gap:10px;align-items:center;padding:10px}
    .ulf-ava{width:40px;height:40px;border-radius:999px;object-fit:cover;background:#e5e7eb;border:2px solid #fff;margin-top:-18px}
    .ulf-ava.placeholder{display:flex;align-items:center;justify-content:center;font-weight:700;color:#374151}
    .ulf-name{font-weight:700;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
    .ulf-meta{font-size:12px;color:#6b7280}
    .ulf-bio{padding:0 10px 10px 10px;color:#374151;font-size:14px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
    .ulf-badge{position:absolute;top:8px;left:8px;background:#111827;color:#fff;font-size:12px;border-radius:999px;padding:2px 8px}
    .ulf-link{position:absolute;right:8px;bottom:8px;border:1px solid #e5e7eb;background:#fff;border-radius:8px;padding:4px 8px;font-size:12px;cursor:pointer}
    @media (prefers-color-scheme: dark){
    .ulf-card{background:#0b0b0d;border-color:#1f2430}
    .ulf-banner{background-color:#161a23}
    .ulf-name{color:#e8eaee}
    .ulf-meta,.ulf-bio{color:#9aa3b2}
    .ulf-link{background:#0b0b0d;color:#e8eaee;border-color:#1f2430}
    }
    /* tabs */
    .ul-tabs{display:flex;gap:8px;margin:10px 0 12px}
    .ul-tab{border:1px solid #e5e7eb;background:#fff;border-radius:8px;padding:8px 12px;cursor:pointer}
    .ul-tab.is-active{background:#111827;color:#fff;border-color:#111827}

    /* activity */
    .ua-toolbar{display:flex;gap:8px;align-items:center;margin:8px 0 12px}
    .ua-feed{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:10px}
    .ua-item{display:flex;gap:10px;border:1px solid #e5e7eb;border-radius:12px;background:#fff;padding:10px}
    .ua-thumb{width:48px;height:48px;border-radius:8px;background:#f3f4f6;object-fit:cover;flex:0 0 auto}
    .ua-main{min-width:0;flex:1}
    .ua-head{display:flex;flex-wrap:wrap;gap:6px;align-items:center}
    .ua-kind{font-size:12px;border:1px solid #e5e7eb;border-radius:999px;padding:2px 8px;background:#fff;color:#374151}
    .ua-title{font-weight:700;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
    .ua-meta{margin-left:auto;font-size:12px;color:#6b7280}
    .ua-text{margin-top:4px;color:#374151;overflow-wrap:anywhere}
    .ul-tabsbar{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:10px 0 12px}
    .ul-actions{display:flex;gap:8px;flex-wrap:wrap}
    .ul-action{
    display:inline-flex;align-items:center;gap:6px;
    border:1px solid #e5e7eb;background:#fff;border-radius:8px;
    padding:8px 12px;font-size:14px;color:#111827;text-decoration:none;
    }
    .ul-action:hover{background:#f8fafc}
    @media (max-width:720px){
    .ul-tabsbar{flex-wrap:wrap}
    .ul-actions{width:100%}
    }
    @media (prefers-color-scheme: dark){
    .ul-action{background:#0b0b0d;color:#e8eaee;border-color:#1f2430}
    .ul-action:hover{background:#111318}
    }
    /* Blog grid */
    .blog-toolbar{display:flex;gap:8px;margin:8px 0 12px}
    #blog-search{flex:1 1 auto;border:1px solid #e5e7eb;border-radius:8px;padding:8px 10px}
    #blog-refresh,#blog-more{border:1px solid #e5e7eb;background:#fff;border-radius:8px;padding:8px 12px;cursor:pointer}

    .blog-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}
    @media (max-width:1100px){.blog-grid{grid-template-columns:repeat(3,1fr)}}
    @media (max-width:800px){.blog-grid{grid-template-columns:repeat(2,1fr)}}
    @media (max-width:520px){.blog-grid{grid-template-columns:1fr}}

    .blog-card{display:flex;flex-direction:column;border:1px solid #e5e7eb;border-radius:12px;background:#fff;overflow:hidden}
    .blog-thumb{aspect-ratio:16/9;background:#f3f4f6 center/cover no-repeat}
    .blog-body{padding:10px}
    .blog-title{font-weight:700;margin:0 0 6px 0;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
    .blog-meta{font-size:12px;color:#6b7280;margin-bottom:6px}
    .blog-excerpt{color:#374151;font-size:14px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
    .blog-card a.stretched{position:relative}
    .blog-card a.stretched::after{content:"";position:absolute;inset:0}
    .gd-empty{padding:24px;color:#6b7280;text-align:center}

    @media (prefers-color-scheme: dark){
    .blog-card{background:#0b0b0d;border-color:#1f2430}
    .blog-meta,.blog-excerpt{color:#9aa3b2}
    }
    `;
    document.head.appendChild(s);
  })();

  // ---- render
  function renderGrid(){
    const grid = document.getElementById('ul-grid');
    const end = (state.page+1)*state.pageSize;
    const items = state.filtered.slice(0, end);

    if (!state.loaded) { grid.innerHTML = `<div class="gd-empty">Loading…</div>`; return; }
    if (!items.length) { grid.innerHTML = `<div class="gd-empty">No users found.</div>`; return; }

    grid.innerHTML = items.map(u=>{
    const name = u.display_name || `User ${String(u.customer_id||'').slice(-6)}`;
    const banner = u.cover_image_url || '';
    const ava = u.avatar_url
        ? `<img class="ul-ava" loading="lazy" src="${esc(u.avatar_url)}" alt="">`
        : `<div class="ul-ava placeholder">${esc(initials(name))}</div>`;
    const lastTitle = u.last_at ? esc(new Date(u.last_at).toLocaleString()) : '';
    const href = profileLink(u);
    const bio = nl2sp(u.bio||'');
    const safeBanner = banner
        ? ` style="background-image:url('${esc(banner)}')"`
        : '';
    const st = onlineStatus(u.last_at);
    const badge = isFeatured(u) ? `<div class="ul-badge">New this week</div>` : '';
    const origin = (new URL('/', window.location.href)).origin;
    const fullLink = origin + href;

    return `
        <div class="ul-card" data-href="${esc(href)}" role="button" tabindex="0">
        ${badge}
        <div class="ul-banner"${safeBanner} loading="lazy"></div>
        <div class="ul-body">
            ${ava}
            <div class="ul-main">
            <div class="ul-name-wrap">
                <span class="ul-name">${esc(name)}</span>
                ${levelPill(u)}
            </div>
            <div class="ul-meta" title="${lastTitle}">${esc(timeAgo(u.last_at))}</div>
            </div>
        </div>
        ${bio ? `<div class="ul-bio">${esc(bio)}</div>` : ''}
        <div class="ul-footer">
            <button class="ul-link" type="button" data-copy="${esc(fullLink)}">Profile 🔗</button>
        </div>
        </div>
    `;
    }).join('');

    const moreBtn = document.getElementById('ul-more');
    if (moreBtn) moreBtn.style.display = state.filtered.length > items.length ? '' : 'none';
  }

  function applyFilter(){
    const q = state.q.trim().toLowerCase();
    state.page = 0;
    state.filtered = !q ? state.all : state.all.filter(u=>{
      const name = (u.display_name||'').toLowerCase();
      const tail = String(u.customer_id||'').slice(-6).toLowerCase();
      return name.includes(q) || tail.includes(q);
    });
    renderGrid();
  }

    async function load(offset = 0, append = false){
    try {
        const qs = state.q ? `&q=${encodeURIComponent(state.q)}` : '';
        const r  = await fetch(`${API_BASE}/user-list?limit=500&offset=${offset}${qs}`, { cache:'no-store' });
        if (!r.ok) throw new Error(r.status);
        const data = await r.json();
        const list = Array.isArray(data?.items) ? data.items : [];

        state.all    = append ? state.all.concat(list) : list; // keep everyone
        state.loaded = true;

        renderFeatured(list); // uses u.joined_at (last 7 days)
        applyFilter();        // grid shows everyone (including featured)
    } catch (e) {
        console.warn('[user-list] load failed', e);
        state.loaded = true;
        state.all = [];
        applyFilter();
    }
    }

  // ---- init
  function init(){
    document.getElementById('ul-search')?.addEventListener('input', (e)=>{
      state.q = e.target.value || '';
      // For server-side filtering, reload; for client-side only, comment next line.
      load(0,false);
    });
    document.getElementById('ul-refresh')?.addEventListener('click', ()=>{
      state.loaded = false; renderGrid(); load(0,false);
    });
    document.getElementById('ul-more')?.addEventListener('click', ()=>{
      state.page += 1; renderGrid();
    });
    load(0,false);

    // Tabs
    const tabs        = document.getElementById('ul-tabs');
    const paneUsers   = document.getElementById('ul-pane-users');
    const paneActivity= document.getElementById('ul-pane-activity');
    const paneBlogs   = document.getElementById('ul-pane-blogs'); // ADD
    let uaLoaded = false;
    let blogBooted = false;

    tabs?.addEventListener('click', async (e)=>{
    const btn = e.target.closest('.ul-tab'); if (!btn) return;
    tabs.querySelectorAll('.ul-tab').forEach(b=>b.classList.toggle('is-active', b===btn));
    const tab = btn.dataset.tab;

    if (paneUsers)    paneUsers.hidden    = tab !== 'users';
    if (paneActivity) paneActivity.hidden = tab !== 'activity';
    if (paneBlogs)    paneBlogs.hidden    = tab !== 'blogs';   // ADD

    if (tab === 'activity' && !uaLoaded) {
        uaLoaded = true;
        await loadActivityFeed({ force:true });
    }
    if (tab === 'blogs' && !blogBooted) {
        blogBooted = true;
        loadBlogs({ reset:true }); // lazy-load blogs first time
    }
    });

    // Activity filter + refresh
    document.getElementById('ua-filter')?.addEventListener('change', ()=>{
    renderActivity(filterActivity(_uaCache.all));
    });
    document.getElementById('ua-refresh')?.addEventListener('click', ()=>{
    loadActivityFeed({ force:true });
    });

    // click card → navigate (ignore copy button)
    document.getElementById('ul-grid')?.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-copy]');
    if (btn) return;
    const card = e.target.closest('.ul-card');
    if (!card) return;
    const href = card.getAttribute('data-href');
    if (href) window.open(href, '_blank', 'noopener');
    });
    // keyboard enter → navigate
    document.getElementById('ul-grid')?.addEventListener('keydown', (e)=>{
    if (e.key !== 'Enter') return;
    const card = e.target.closest('.ul-card');
    if (!card) return;
    const href = card.getAttribute('data-href');
    if (href) window.open(href, '_blank', 'noopener');
    });

    // copy button
    document.getElementById('ul-grid')?.addEventListener('click', async (e)=>{
    const btn = e.target.closest('[data-copy]');
    if (!btn) return;
    e.stopPropagation();
    const url = btn.getAttribute('data-copy');
    try {
        await navigator.clipboard.writeText(url);
        const old = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(()=>btn.textContent = old, 1200);
    } catch {
        const old = btn.textContent;
        btn.textContent = 'Copy failed';
        setTimeout(()=>btn.textContent = old, 1200);
    }
    });

    // Blog controls  // ADD
    document.getElementById('blog-refresh')?.addEventListener('click', ()=> loadBlogs({ reset:true }));
    document.getElementById('blog-more')?.addEventListener('click', ()=> { BLOG.page += 1; renderBlogs(); });

    (() => { // simple debounce
    const inp = document.getElementById('blog-search');
    if (!inp) return;
    let t;
    inp.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(() => { BLOG.q = (inp.value||'').trim(); loadBlogs({ reset:true }); }, 300);
    });
    })();

    // 1) Featured: click card → open profile
    document.getElementById('ul-featured')?.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-copy]'); if (btn) return;   // ignore copy button
    const card = e.target.closest('.ulf-card'); if (!card) return;
    const href = card.getAttribute('data-href'); if (href) window.open(href, '_blank', 'noopener');
    });

    // 2) Featured: Enter key → open profile
    document.getElementById('ul-featured')?.addEventListener('keydown', (e)=>{
    if (e.key !== 'Enter') return;
    const card = e.target.closest('.ulf-card'); if (!card) return;
    const href = card.getAttribute('data-href'); if (href) window.open(href, '_blank', 'noopener');
    });

    // 3) Featured: copy link button
    document.getElementById('ul-featured')?.addEventListener('click', async (e)=>{
    const btn = e.target.closest('[data-copy]'); if (!btn) return;
    e.stopPropagation();
    const url = btn.getAttribute('data-copy');
    try {
        await navigator.clipboard.writeText(url);
        const old = btn.textContent; btn.textContent = 'Copied!'; setTimeout(()=>btn.textContent = old, 1200);
    } catch {
        const old = btn.textContent; btn.textContent = 'Copy failed'; setTimeout(()=>btn.textContent = old, 1200);
    }
    });

  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
